export default __webpack_public_path__ + "static/media/rupees.c6d2081c.svg";